import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';

export default function Counter({ value, duration = 2000, decimals = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-50px' });
  const [num, setNum] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const target = parseFloat(value);
    const start = performance.now();
    let raf;
    const step = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setNum(target * eased);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration]);

  const display = decimals > 0 ? num.toFixed(decimals) : Math.round(num).toLocaleString('tr-TR');
  return <motion.span ref={ref}>{display}</motion.span>;
}
